export enum FiltroTiempoEstadisticas {
  Diario = 'Diario',  
  Semanal = 'Semanal',
    Mensual = 'Mensual',
    Anual = 'Anual'
  }
